import React from 'react';
import { CheckIcon } from 'lucide-react';
export const CTASection = () => {
  return <section className="w-full bg-indigo-900 py-16 md:py-24" data-id="element-151">
      <div className="container mx-auto px-4 md:px-6" data-id="element-152">
        <div className="max-w-4xl mx-auto" data-id="element-153">
          <div className="flex flex-col md:flex-row items-center mb-10" data-id="element-154">
            <div className="md:w-1/2 mb-8 md:mb-0 md:pr-8" data-id="element-155">
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-156">
                Choose Restful, Natural Sleep with Setu Sleep Restore Tonight
              </h2>
              <p className="text-indigo-100 mb-6 md:text-lg" data-id="element-157">
                You have a choice: continue the cycle of dependency with
                sleeping pills, or support your body's natural ability to sleep
                deeply and wake refreshed with our convenient mint-flavored
                strips.
              </p>
              <p className="text-indigo-100 mb-6 md:text-lg" data-id="element-158">
                4,00,000+ Indians have already made the switch to Setu's Sleep
                Restore Melatonin Strips. Join them in experiencing what real,
                restorative sleep feels like.
              </p>
              <div className="bg-indigo-800 rounded-lg p-4 mb-6 inline-block" data-id="element-159">
                <p className="text-white" data-id="element-160">
                  Special for first-time customers: Use code{' '}
                  <span className="font-bold text-green-400" data-id="element-161">NATURAL15</span>{' '}
                  for 15% off your first order.
                </p>
              </div>
            </div>
            <div className="md:w-1/2 flex justify-center" data-id="element-162">
              <div className="relative bg-indigo-800 p-6 rounded-lg" data-id="element-163">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/og45cR6GEKB2RvPaD1aJ2B/Screenshot_2025-08-25_at_9.01.12_PM.png" alt="Sleep Restore Melatonin Strips" className="rounded-lg shadow-xl w-full max-w-xs object-contain" data-id="element-164" />
                <div className="absolute -top-4 -right-4 bg-green-500 text-white p-3 rounded-full shadow-lg" data-id="element-165">
                  <p className="text-sm font-bold" data-id="element-166">15% OFF</p>
                </div>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-10" data-id="element-167">
            <div className="bg-indigo-800 rounded-lg p-4 flex items-start" data-id="element-168">
              <CheckIcon className="h-5 w-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-169" />
              <span className="text-white" data-id="element-170">5mg Melatonin</span>
            </div>
            <div className="bg-indigo-800 rounded-lg p-4 flex items-start" data-id="element-171">
              <CheckIcon className="h-5 w-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-172" />
              <span className="text-white" data-id="element-173">30 Mint-flavored Strips</span>
            </div>
            <div className="bg-indigo-800 rounded-lg p-4 flex items-start" data-id="element-174">
              <CheckIcon className="h-5 w-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-175" />
              <span className="text-white" data-id="element-176">Wake up energized, not groggy</span>
            </div>
            <div className="bg-indigo-800 rounded-lg p-4 flex items-start" data-id="element-177">
              <CheckIcon className="h-5 w-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-178" />
              <span className="text-white" data-id="element-179">30-day money-back guarantee</span>
            </div>
            <div className="bg-indigo-800 rounded-lg p-4 flex items-start" data-id="element-180">
              <CheckIcon className="h-5 w-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-181" />
              <span className="text-white" data-id="element-182">Free shipping across India</span>
            </div>
            <div className="bg-indigo-800 rounded-lg p-4 flex items-start" data-id="element-183">
              <CheckIcon className="h-5 w-5 text-green-400 mr-2 flex-shrink-0 mt-0.5" data-id="element-184" />
              <span className="text-white" data-id="element-185">Pharmaceutical Grade Quality</span>
            </div>
          </div>
          <div className="flex flex-col sm:flex-row justify-center space-y-4 sm:space-y-0 sm:space-x-6" data-id="element-186">
            <a href="#buy-now" className="bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-full font-bold text-lg shadow-lg transition-colors" data-id="element-187">
              Get Sleep Restore Strips Now
            </a>
            <a href="#guarantee" className="bg-transparent hover:bg-indigo-800 text-white border-2 border-indigo-300 px-8 py-4 rounded-full font-bold text-lg transition-colors" data-id="element-188">
              Try Risk-Free for 30 Days
            </a>
          </div>
          <div className="mt-12 flex justify-center" data-id="element-189">
            <img src="https://images.unsplash.com/photo-1455642305367-68834a1da7ab?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1740&q=80" alt="Peaceful sleep visualization" className="rounded-lg shadow-xl w-full max-w-2xl object-cover" onError={e => {
            e.target.src = 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1742&q=80';
          }} data-id="element-190" />
          </div>
        </div>
      </div>
    </section>;
};